'use strict';

const jQuery = require('jquery');

const Auth = require('./../../../services/auth');
const container = require('./../../../core/container');
const mediator = require('./../../../core/mediator');
const RequestHandler = require('./../../../core/requestHandler');
const Translator = require('./../../../core/translator');
const PopinManager = require('./../../../services/popin');
const Menu = require('./../../../services/structure/menu/desktop');
const Loader = require('./../../../services/loader');
const SaveManager = require('./../../content/component/SaveManager');
const ContentRepository = require('./../../content/repository/ContentRepository');

module.exports.onLogout = function(reload, popin = true) {
  let dfd = jQuery.Deferred();
  let isDrafted = jQuery('.btn-publish').hasClass('is-drafted');
  let config = {};

  if (typeof reload === 'object') {
    popin = reload.popin;
    reload = reload.reload;
  }

  config.firstBtn = isDrafted ? 'logout' : 'cancel-auth';
  config.firstBtnClass = isDrafted ? '' : 'popin popin-cancel';
  config.secondBtn = isDrafted ? 'logout_button_publish' : 'submit';
  config.message = isDrafted ? 'logout_message_publish': 'logout_message';

  let callback = function() {
    let config = {'reload': reload};

    mediator.publish('before:logout', config);

    RequestHandler.del('security/session').done(function() {
      document.cookie = 'PHPSESSID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';

      mediator.publish('after:logout', config);

      if (false !== config.reload) {
        location.reload();
      }

      dfd.resolve();
    }).fail(function() {
      dfd.reject();
    });

    Auth.clearState();
  };

  Menu.unFocus();

  if (popin !== false) {
    let logo ='';
    let configPopin = {
      'classes': {
        'ui-dialog': 'ui-dialog cloud-dialog ui-widget ui-widget-content ui-front ui-dialog-buttons ui-draggable ui-resizable',
      },
      'title': Translator.translate('logout'),
      'height': 200,
      'width': isDrafted ? 500 : 350,
      'buttons': [
        {
          class: isDrafted ? 'popin popin-cancel' : 'd-none',
          text: Translator.translate('discard'),
          click: function() {
            popin.hide();
            dfd.resolve();
          },
        },
        {
          class: config.firstBtnClass,
          text: Translator.translate(config.firstBtn),
          click: function() {
            if (isDrafted) {
              callback();
            } else {
              popin.hide();
              dfd.resolve();
            }
          },
        },
        {
          text: Translator.translate(config.secondBtn),
          click: function() {
            Loader.start(popin.rootElement.find('.popin-content'));

            if (isDrafted) {
              SaveManager.save().done(function() {
                ContentRepository.publish().done(callback);
              });
            } else {
              callback();
            }
          },
        },
      ],
    };

    if (container.get('isMobile')) {
      configPopin.classes = {
        ...configPopin.classes,
        'ui-dialog': 'cloud-dialog auth-mobile logout',
      };
      logo = `<i class="icon icon-backbee"></i>`;
    }

    popin = PopinManager.createPopin(configPopin);

    popin.setContent(`<p>${Translator.translate(config.message)}</p>` + logo);

    popin.display();
  } else {
    callback();
  }
  return dfd.promise();
};

module.exports.afterLogout = function(config) {
  config.reload = false;

  if (container.get('page.is_online')) {
    location.reload();
  } else {
    location.replace('/');
  }
};
